/**
 * Pure role-routing rules. UI convenience only — RLS enforces data access.
 */

/** Driver-app users: driver, optionally with analyst, and nothing else. */
export function shouldRedirectToDriver(roles: readonly string[]): boolean {
  return roles.includes("driver") && roles.every((r) => r === "driver" || r === "analyst");
}

/** Terminal staff without office access: only terminal_staff and/or driver roles. */
export function shouldRedirectToYard(roles: readonly string[]): boolean {
  return (
    roles.includes("terminal_staff") &&
    roles.every((r) => r === "terminal_staff" || r === "driver")
  );
}

/** Office surfaces are read-only for analysts without admin/dispatcher. */
export function isOfficeReadOnly(roles: readonly string[]): boolean {
  return roles.includes("analyst") && !roles.includes("admin") && !roles.includes("dispatcher");
}

/** Roles allowed to perform yard check-in/out/audit actions. */
export function canUseYard(roles: readonly string[]): boolean {
  return roles.some((r) => r === "admin" || r === "dispatcher" || r === "terminal_staff");
}

/** Note composition is independent of the office editing gate; RLS enforces writes. */
export function canWriteOrderNotes(roles: readonly string[]): boolean {
  return roles.some((r) => r === "admin" || r === "dispatcher" || r === "driver" || r === "terminal_staff");
}
